// "use client"
import { useState, useEffect } from 'react';

const Hint = ({ message, state }) => {




  useEffect(() => {
    // Only set the timeout if there's something to close (i.e., success or error message is visible)
    if (state.success || state.error) {
      let timer = setTimeout(() => { handleClose(); }, 4000);
      // Cleanup timeout on component unmount or if state changes before the timeout completes
      return () => clearTimeout(timer);
    }
    // This effect depends on state.success and state.error, so include them in the dependency array
  }, [state.success, state.error]); // Add state.success and state.error to the dependency array
  

  

  const handleClose = () => {
    // callback({action: "alertControl", success: false, error:false})
    state.setSuccess(false);
    state.setError(false);
  };

  return (
    <>

     <div className="ml-14 flex justify-center items-center">
     
     <div
       className={`fixed text-sm rounded-l-xl shadow-xl z-50 bottom-3 right-0 w-3/5 md:w-2/4 lg:w-1/4 p-4 font-medium bg-yellow-50 dark:bg-gray-950 border-gray-400 dark:border-gray-700 text-yellow-800 dark:text-yellow-500 transition-transform duration-300 transform ${state.hint ? 'translate-y-0' : 'translate-y-24'} `}
     >



       <div className="flex justify-between items-center">

         <p>
          <i className="fa-solid fa-circle-info pr-2"></i> 
          {message}
          </p>
         {/* <button onClick={()=>{handleClose()}} className="text-sm">
           Close
         </button> */}




       </div>
     </div>
   </div>
</>
  );
};

export default Hint;